
	import ModeloUpdatePagina from '@/views/paginas/sigap/modelos/ModeloUpdatePagina.vue';   
    import { Options   } from "vue-class-component"; 
    import {  Instrutor } from "./Instrutor"; 
    import   SiteUtils   from '@/assets/ts/aplicacao/site';
    import { PerfilConfig } from "@/core/config/PerfisConfig";
    import InstrutorService from   "@/service/v1/sigap/InstrutorService"  

    @Options({
        name: "InstrutorEdicao",
        components: {   },   
    }) 
    export default class InstrutorEdicao extends ModeloUpdatePagina {
           
        async created() {  
            this.campos =  Instrutor.campos();   
            this.service = new InstrutorService();
            await this.buscarEscolaridades();
            await this.buscarTipoPagamento();
            await this.buscarTipo();
            this.buscaInstrutor();
        }
 
        public async buscarEscolaridades(){   
            await this.service.getEscolaridades(  ).then(response =>{ 
               this.campos.push(
                    {
                        nome: "escolaridade",
                        type: "select",
                        label: "Escolaridade",
                        sm: 6,
                        lg: 6, 
                        disabled: false,
                        options: response.map((item) => { return { value: item.id, label: item.nome } })
                    },
                );
            });
        }
    
        public async buscarTipoPagamento(){
            await this.service.getTipoPagamento(  ).then(response =>{
               this.campos.push(
                    {
                        nome: "tipoPagamento",
                        type: "select",
                        label: "Tipo de Pagamento",
                        sm: 6,
                        lg: 6,
                        disabled: false,
                        options: response.map((item) => { return { value: item.id, label: item.nome } })
                    },
                );
            });
        }

        public async buscarTipo(){
            await this.service.getTipo(  ).then(response =>{
               this.campos.push(
                    {
                        nome: "tipo",
                        type: "select",
                        label: "Tipo de Instrutor",
                        sm: 6,
                        lg: 6,
                        disabled: false,
                        options: response.map((item) => { return { value: item.id, label: item.nome } })
                    },
                );
            });
        }
   
        get hasPermissao(   ): boolean {
            return SiteUtils.hasPermissao( [ PerfilConfig.Admin ,  PerfilConfig.ChefeSTE ] ,  this.perfis); 
        }
 
        public buscaInstrutor(){   
            this.processando = true ; 
            this.service.getModel( this.$route.params.id  ) 
            .then(response => {   
                this.modelo =  JSON.parse(JSON.stringify( response ));   
                this.processando = false ;    
            })
            .catch(error => { 
                this.processando = false ; 
            }); 
        } 
 
        public modeloAlterado(){   
            this.formulario = {}
            if(this.modelo){  
                this.service.getModel(this.modelo.id) 
                .then(response => {   
                    this.formulario =  JSON.parse(JSON.stringify( response ));  
                    this.formulario.escolaridade = this.formulario.escolaridade.id;
                    this.formulario.tipoPagamento = this.formulario.tipoPagamento.id;
                    this.formulario.status = this.formulario.status.id;
                    this.formulario.tipo = this.formulario.tipo ? this.formulario.tipo.id : 1;
                })
                .catch(error => {
                    this.formulario = { };  
                });  
            } 
        }
 
        public sucesso(){  
            this.$router.push({ name: "sigap_Instrutor"  })
        }
        
    } 
